export const alphasOptions = {
  id: {
    type: 'string',
    required: false,
    readOnly: true,
  },
  settings: {
    type: 'nested object',
    required: true,
    readOnly: false,
    children: {
      region: {
        type: 'choice',
        required: true,
        readOnly: false,
        choices: [
          {
            value: 'USA',
            label: 'USA',
          },
        ],
      },
      universe: {
        type: 'choice',
        required: true,
        readOnly: false,
        choices: {
          region: {
            USA: [
              {
                value: 'TOP3000',
                label: 'TOP3000',
              },
              {
                value: 'TOP2000',
                label: 'TOP2000',
              },
              {
                value: 'TOP1000',
                label: 'TOP1000',
              },
              {
                value: 'TOP500',
                label: 'TOP500',
              },
              {
                value: 'TOP200',
                label: 'TOP200',
              },
            ],
          },
        },
      },
      delay: {
        type: 'choice',
        required: true,
        readOnly: false,
        choices: {
          region: {
            USA: [
              {
                value: 0,
                label: '0',
              },
              {
                value: 1,
                label: '1',
              },
            ],
          },
        },
      },
      decay: {
        type: 'integer',
        required: true,
        readOnly: false,
        minValue: 0,
      },
      neutralization: {
        type: 'choice',
        required: true,
        readOnly: false,
        choices: [
          {
            value: 'NONE',
            label: 'None',
          },
          {
            value: 'MARKET',
            label: 'Market',
          },
          {
            value: 'INDUSTRY',
            label: 'Industry',
          },
          {
            value: 'SUBINDUSTRY',
            label: 'Subindustry',
          },
        ],
      },
      truncation: {
        type: 'float',
        required: true,
        readOnly: false,
        minValue: 0,
        maxValue: 1,
      },
      language: {
        type: 'choice',
        required: true,
        readOnly: false,
        choices: [
          {
            value: 'PYTHON',
            label: 'Python',
          },
          {
            value: 'EXPRESSION',
            label: 'Expression',
          },
          {
            value: 'FASTEXPR',
            label: 'Fast Expression',
          },
        ],
      },
      visualization: {
        type: 'boolean',
        required: true,
        readOnly: false,
      },
    },
  },
  code: {
    type: 'string',
    required: true,
    readOnly: false,
  },
  dateCreated: {
    type: 'datetime',
    required: true,
    readOnly: false,
  },
  dateSubmitted: {
    type: 'datetime',
    required: false,
    readOnly: true,
  },
  name: {
    type: 'string',
    required: true,
    readOnly: false,
  },
  description: {
    type: 'string',
    required: true,
    readOnly: false,
  },
  favorite: {
    type: 'boolean',
    required: true,
    readOnly: false,
  },
  hidden: {
    type: 'boolean',
    required: true,
    readOnly: false,
  },
  color: {
    type: 'choice',
    required: true,
    readOnly: false,
    choices: [
      {
        value: 'RED',
        label: 'Red',
      },
      {
        value: 'YELLOW',
        label: 'Yellow',
      },
      {
        value: 'GREEN',
        label: 'Green',
      },
      {
        value: 'BLUE',
        label: 'Blue',
      },
      {
        value: 'PURPLE',
        label: 'Purple',
      },
    ],
  },
  category: {
    type: 'choice',
    required: true,
    readOnly: false,
    choices: [
      {
        value: 'PRICE_REVERSION',
        label: 'Price Reversion',
      },
      {
        value: 'PRICE_MOMENTUM',
        label: 'Price Momentum',
      },
      {
        value: 'VOLUME',
        label: 'Volume',
      },
      {
        value: 'FUNDAMENTAL',
        label: 'Fundamental',
      },
      {
        value: 'ANALYST',
        label: 'Analyst',
      },
      {
        value: 'PRICE_VOLUME',
        label: 'Price Volume',
      },
      {
        value: 'RELATION',
        label: 'Relation',
      },
      {
        value: 'SENTIMENT',
        label: 'Sentiment',
      },
    ],
  },
  tags: {
    type: 'list',
    required: true,
    readOnly: false,
    child: {
      type: 'string',
      required: true,
      readOnly: false,
    },
    choices: [
      {
        value: 'Tag',
        label: 'Tag',
      },
    ],
  },
  grade: {
    type: 'field',
    required: false,
    readOnly: true,
  },
  stage: {
    type: 'choice',
    required: true,
    readOnly: false,
    choices: [
      {
        value: 'IS',
        label: 'IS',
      },
      {
        value: 'OS',
        label: 'OS',
      },
      {
        value: 'PROD',
        label: 'PROD',
      },
    ],
  },
  status: {
    type: 'choice',
    required: true,
    readOnly: false,
    choices: [
      {
        value: 'UNSUBMITTED',
        label: 'UNSUBMITTED',
      },
      {
        value: 'OSTEST-PENDING',
        label: 'OSTEST-PENDING',
      },
      {
        value: 'OSTEST-PASS',
        label: 'OSTEST-PASS',
      },
      {
        value: 'OSTEST-FAIL',
        label: 'OSTEST-FAIL',
      },
      {
        value: 'OSTEST-DECM',
        label: 'OSTEST-DECM',
      },
      {
        value: 'OSTEST-CORR-PASS',
        label: 'OSTEST-CORR-PASS',
      },
      {
        value: 'OSTEST2-PENDING',
        label: 'OSTEST2-PENDING',
      },
      {
        value: 'PROD-PENDING',
        label: 'PROD-PENDING',
      },
      {
        value: 'PROD',
        label: 'PROD',
      },
      {
        value: 'PROD-DECM',
        label: 'PROD-DECM',
      },
      {
        value: 'PROD-HOLD',
        label: 'PROD-HOLD',
      },
    ],
  },
  is: {
    type: 'nested object',
    required: true,
    readOnly: false,
    child: {
      type: 'field',
      required: true,
      readOnly: false,
    },
  },
  os: {
    type: 'nested object',
    required: true,
    readOnly: false,
    child: {
      type: 'field',
      required: true,
      readOnly: false,
    },
  },
  prod: {
    type: 'nested object',
    required: true,
    readOnly: false,
    child: {
      type: 'field',
      required: true,
      readOnly: false,
    },
  },
  competitions: {
    type: 'choice',
    required: true,
    readOnly: false,
    choices: [
      {
        value: 'solveathon2015',
        label: 'Solve-a-thon 2015',
      },
      {
        value: 'IQC2018S1',
        label: 'International Quant Championship Stage 1',
      },
      {
        value: 'challenge',
        label: 'Challenge',
      },
    ],
  },
  team: {
    type: 'field',
    required: false,
    readOnly: true,
  },
};

export const alphaDetail = {
  settings: {
    instrumentType: 'EQUITY',
    delay: 1,
    visualization: false,
    universe: 'TOP3000',
    truncation: 0.1,
    region: 'USA',
    language: 'EXPRESSION',
    decay: 1,
    neutralization: 'SUBINDUSTRY',
  },
  color: null,
  os: null,
  is: {
    details: {
      schema: {
        name: 'is',
        title: 'IS',
        properties: [
          {
            name: 'year',
            title: 'Year',
            type: 'year',
          },
          {
            name: 'pnl',
            title: 'PnL',
            type: 'amount',
          },
          {
            name: 'bookSize',
            title: 'Book Size',
            type: 'amount',
          },
          {
            name: 'longCount',
            title: 'Long Count',
            type: 'integer',
          },
          {
            name: 'shortCount',
            title: 'Short Count',
            type: 'integer',
          },
          {
            name: 'turnover',
            title: 'Turnover',
            type: 'percent',
          },
          {
            name: 'sharpe',
            title: 'Sharpe',
            type: 'decimal',
          },
          {
            name: 'returns',
            title: 'Returns',
            type: 'percent',
          },
          {
            name: 'drawdown',
            title: 'Drawdown',
            type: 'percent',
          },
          {
            name: 'margin',
            title: 'Margin',
            type: 'permyriad',
          },
          {
            name: 'fitness',
            title: 'Fitness',
            type: 'decimal',
          },
        ],
      },
      records: [['', 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]],
    },
    returns: 0,
    drawdown: 0,
    fitness: 0,
    bookSize: 0,
    checks: [
      {
        name: 'LOW_FITNESS',
        result: 'FAIL',
        limit: 1,
        value: 0,
      },
      {
        name: 'LOW_SHARPE',
        result: 'FAIL',
        limit: 1.25,
        value: 0,
      },
      {
        name: 'LOW_TURNOVER',
        result: 'FAIL',
        limit: 0.01,
        value: 0,
      },
      {
        name: 'HIGH_TURNOVER',
        result: 'PASS',
        limit: 0.7,
        value: 0,
      },
      {
        name: 'CONCENTRATED_WEIGHT',
        limit: 1,
        value: 0.2,
        result: 'PASS',
      },
      {
        name: 'SELF_CORRELATION',
        result: 'PENDING',
      },
      {
        name: 'SUB_UNIVERSE_SHARPE',
        result: 'PASS',
        limit: 0,
        value: 1,
      },
      {
        name: 'IS_LADDER_SHARPE',
        result: 'PENDING',
      },
    ],
    margin: 0,
    pnl: 0,
    turnover: 0,
    shortCount: 0,
    longCount: 0,
    sharpe: 0,
  },
  hidden: false,
  name: null,
  dateSubmitted: null,
  code: '1',
  status: 'UNSUBMITTED',
  competitions: [
    {
      id: 'challenge',
      name: 'Challenge',
    },
    {
      id: 'summerthon2017',
      name: 'Summer Alphathon 2017',
    },
  ],
  prod: null,
  grade: 'INFERIOR',
  tags: [],
  dateCreated: '2018-12-25T17:38:03-01:00',
  id: 'vgA3lxa',
  favorite: false,
  description: null,
  team: {
    id: 'NdKvn6Z',
    type: 'IQC2018S1',
    name: 'GN12365',
  },
  category: null,
  stage: 'IS',
};

export const summaryTable = {
  is: {
    data: [
      ['2013', '1,94', '17,72%', '1,74', '14,22%', '16,05‱', 112, 2867, 'IS'],
      ['2014', '-1,37', '18,38%', '-1,09', '-11,66%', '-12,69‱', 102, 2875, 'IS'],
      ['2015', '-0,35', '17,72%', '-0,15', '-3,33%', '-3,76‱', 94, 2869, 'IS'],
      ['2016', '-0,23', '18,19%', '-0,08', '-2,37%', '-2,61‱', 97, 2875, 'IS'],
      ['2017', '1,95', '19,85%', '1,83', '17,46%', '17,59‱', 101, 2883, 'IS'],
      ['2018', '-2,03', '21,75%', '-1,65', '-14,45%', '-13,29‱', 93, 2889, 'IS'],
    ],
    header: [
      {
        id: 'year',
        type: 'year',
        title: 'alphaSummary.year',
      },
      {
        id: 'sharpe',
        type: 'decimal',
        title: 'alphaSummary.sharpe',
      },
      {
        id: 'turnover',
        type: 'percent',
        title: 'alphaSummary.turnover',
      },
      {
        id: 'fitness',
        type: 'decimal',
        title: 'alphaSummary.fitness',
      },
      {
        id: 'returns',
        type: 'percent',
        title: 'alphaSummary.returns',
      },
      {
        id: 'margin',
        type: 'permyriad',
        title: 'alphaSummary.margin',
      },
      {
        id: 'longCount',
        type: 'integer',
        title: 'alphaSummary.longCount',
      },
      {
        id: 'shortCount',
        type: 'integer',
        title: 'alphaSummary.shortCount',
      },
      {
        id: 'stage',
        type: 'string',
        title: 'alphaSummary.stage',
      },
    ],
    types: ['year', 'decimal', 'percent', 'decimal', 'percent', 'permyriad', 'integer', 'integer', 'string'],
    dataType: ['string', 'number', 'number', 'number', 'number', 'number', 'number', 'number', 'number', 'number', 'number', 'string'],
  },
};

export const summaryOSPROD = {
  is: {
    data: [['', '0.00', '0.00%', '0.00', '0.00%', '0.00%', '0.00‱', 0, 0, undefined]],
    header: [
      {
        id: 'year',
        type: 'year',
        title: 'alphaSummary.year',
      },
      {
        id: 'sharpe',
        type: 'decimal',
        title: 'alphaSummary.sharpe',
      },
      {
        id: 'turnover',
        type: 'percent',
        title: 'alphaSummary.turnover',
      },
      {
        id: 'fitness',
        type: 'decimal',
        title: 'alphaSummary.fitness',
      },
      {
        id: 'returns',
        type: 'percent',
        title: 'alphaSummary.returns',
      },
      {
        id: 'drawdown',
        type: 'percent',
        title: 'alphaSummary.drawdown',
      },
      {
        id: 'margin',
        type: 'permyriad',
        title: 'alphaSummary.margin',
      },
      {
        id: 'longCount',
        type: 'integer',
        title: 'alphaSummary.longCount',
      },
      {
        id: 'shortCount',
        type: 'integer',
        title: 'alphaSummary.shortCount',
      },
      {
        id: 'stage',
        type: 'string',
        title: 'alphaSummary.stage',
      },
    ],
    types: ['year', 'decimal', 'percent', 'decimal', 'percent', 'percent', 'permyriad', 'integer', 'integer', 'string'],
    dataType: ['string', 'number', 'number', 'number', 'number', 'number', 'number', 'number', 'number', 'number', 'number'],
  },
};

export const alphasIntro = {
  count: 1,
  next: null,
  previous: null,
  results: [
    {
      id: 'vgA3lxa',
      settings: {
        region: 'USA',
        universe: 'TOP3000',
        delay: 1,
        decay: 1,
        neutralization: 'SUBINDUSTRY',
        truncation: 0.1,
        language: 'EXPRESSION',
        visualization: false,
        instrumentType: 'EQUITY',
      },
      code: '1',
      dateCreated: '2018-12-25T17:38:03-01:00',
      dateSubmitted: null,
      name: null,
      description: null,
      favorite: false,
      hidden: false,
      color: null,
      category: null,
      tags: [],
      grade: 'INFERIOR',
      stage: 'IS',
      status: 'UNSUBMITTED',
      is: {
        pnl: 0,
        bookSize: 0,
        longCount: 0,
        shortCount: 0,
        turnover: 0.0,
        sharpe: 0.0,
        returns: 0.0,
        drawdown: 0.0,
        margin: 0.0,
        fitness: 0.0,
        details: {
          schema: {
            name: 'is',
            title: 'IS',
            properties: [
              { name: 'year', title: 'Year', type: 'year' },
              { name: 'pnl', title: 'PnL', type: 'amount' },
              { name: 'bookSize', title: 'Book Size', type: 'amount' },
              { name: 'longCount', title: 'Long Count', type: 'integer' },
              { name: 'shortCount', title: 'Short Count', type: 'integer' },
              { name: 'turnover', title: 'Turnover', type: 'percent' },
              { name: 'sharpe', title: 'Sharpe', type: 'decimal' },
              { name: 'returns', title: 'Returns', type: 'percent' },
              { name: 'drawdown', title: 'Drawdown', type: 'percent' },
              { name: 'margin', title: 'Margin', type: 'permyriad' },
              { name: 'fitness', title: 'Fitness', type: 'decimal' },
            ],
          },
          records: [['', 0, 0, 0, 0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]],
        },
        checks: [
          { name: 'LOW_FITNESS', result: 'FAIL', limit: 1.0, value: 0.0 },
          { name: 'LOW_SHARPE', result: 'FAIL', limit: 1.25, value: 0.0 },
          { name: 'LOW_TURNOVER', result: 'FAIL', limit: 0.01, value: 0.0 },
          { name: 'HIGH_TURNOVER', result: 'PASS', limit: 0.7, value: 0.0 },
          { name: 'CONCENTRATED_WEIGHT', limit: 1, value: 0.2, result: 'PASS' },
          { name: 'SELF_CORRELATION', result: 'PENDING' },
          { name: 'SUB_UNIVERSE_SHARPE', result: 'PASS', limit: 0.0, value: 1.0 },
          { name: 'IS_LADDER_SHARPE', result: 'PENDING' },
        ],
      },
      os: null,
      prod: null,
      competitions: [
        { id: 'challenge', name: 'Challenge' },
        { id: 'summerthon2017', name: 'Summer Alphathon 2017' },
      ],
      team: {
        id: 'NdKvn6Z',
        type: 'IQC2018S1',
        name: 'GN12365',
      },
    },
  ],
};
